import React, { useCallback, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import AppContext from "../../AppContext";
import PlanTag from "./PlanTag";
import Rating from "./Rating";

import programSketchUpImage from "../../assets/icons/programs/sketchUp.png";
import program3dsMaxImage from "../../assets/icons/programs/3dsMax.png";
import programRevitImage from "../../assets/icons/programs/autodeskRevit.png";
import programCinema4DImage from "../../assets/icons/programs/cinema4d.png";
import programUnrealImage from "../../assets/icons/programs/unreal.png";
import programRhinoImage from "../../assets/icons/programs/rhino.png";
import programAutocadImage from "../../assets/icons/programs/autocad.png";
import programArchicadImage from "../../assets/icons/programs/archicad.png";

import programVRayImage from "../../assets/icons/programs/vray.png";
import programCoronaImage from "../../assets/icons/programs/corona.png";
import programD5RenderImage from "../../assets/icons/programs/d5render.png";
import programEnscapeImage from "../../assets/icons/programs/enscape.jpg";
import programLumionImage from "../../assets/icons/programs/lumion.png";

import { ReactComponent as MessageSvg } from "../../assets/profile/message.svg";
import ChatSessionContext from "../../contexts/ChatSessionContext";

const assetsUri = import.meta.env.ASSETS_URI;

const PROGRAMS = {
  1: programSketchUpImage,
  2: program3dsMaxImage,
  3: programRevitImage,
  4: programCinema4DImage,
  5: programUnrealImage,
  6: programRhinoImage,
  7: programAutocadImage,
  8: programArchicadImage,
};

const RENDERERS = {
  1: programVRayImage,
  2: programCoronaImage,
  3: programLumionImage,
  4: programEnscapeImage,
  5: programD5RenderImage,
};

/**
 * Project Description banner to display
 * @param {*} props `{ user: User, work.name }`
 * @returns
 */
const ProjectDescription = ({
  workId,
  userId,
  avatar,
  ownerName,
  plan,
  workName,
  company,
  rating = 0,
  program,
  renderer,
}) => {
  const { plans, viewProfile, viewCompany, isAuth, user, toggleAuthModal } =
    useContext(AppContext);
  const { startChat } = useContext(ChatSessionContext);
  const [userPlan, setUserPlan] = useState(undefined);
  const [isCreator, setIsCreator] = useState(
    company ? user?.company === company._id : user?._id === userId
  );
  const [isOneLine] = useState(workName.length <= 24);

  // const titleRef = useCallback((node) => {
  //   if (node === null) return;

  //   // const _temp = node.getClientRects()?.length;

  //   // console.log("_temp", _temp);

  //   // if ()

  //   // const resizeObserver = new ResizeObserver((entries) => {
  //   //   const _lines = entries[0].getClientRects();
  //   //   debugger;
  //   //   setIsOneLine(_lines === 1);
  //   // });

  //   // resizeObserver.observe(node);
  // }, []);

  useEffect(() => {
    // * Get user's plan
    const _plan = plans?.find((p) => p._id === plan);
    setUserPlan(_plan?.name.toLowerCase());
  }, []);

  useEffect(() => {
    setIsCreator(
      company ? user?.company === company._id : user?._id === userId
    );
  }, [isAuth, user]);

  const handleProfileClick = (e) => {
    e.stopPropagation();

    if (company) {
      viewCompany(company._id);
      return;
    }

    viewProfile(userId);
  };

  const handleChatClick = () => {
    if (!isAuth) {
      toggleAuthModal(true, undefined, `/projects/${workId}?chat`);
      return;
    }

    startChat(company ? company._id : userId, user._id, {
      work: workId,
    });
  };

  return (
    <div
      className={`project-desc  ${isOneLine ? "project-desc--oneline" : ""}`}
    >
      <img
        className="project-desc__avatar"
        alt="avatar"
        src={`${assetsUri}/${company?.logo ?? avatar}`}
        onClick={handleProfileClick}
      />
      <div className="project-desc-detail">
        <div className="project-desc-detail__header">
          <PlanTag type={userPlan} />
          <div className="project-desc-detail-programs">
            {program && (
              <img
                className="project-desc-detail-programs__icon"
                src={PROGRAMS[program]}
                width={18}
              />
            )}
            {renderer && (
              <img
                className="project-desc-detail-programs__icon"
                src={RENDERERS[renderer]}
                width={18}
              />
            )}
          </div>
        </div>
        <span
          className={`project-desc-detail__name`}
          onClick={handleProfileClick}
        >
          {workName}
        </span>
        <div style={{ flexGrow: 1 }} />
        <div className="project-desc-detail__rating">
          <Rating score={rating} readOnly />
          {!isCreator && (
            <div
              className="work-exchange-view-header-info__avatar__info__chat"
              onClick={handleChatClick}
            >
              <MessageSvg
                className="work-exchange-view-header-info__avatar__info__chat__icon"
                width="22"
                height="22"
              />
              <span className="work-exchange-view-header-info__avatar__info__chat__text">
                Get in touch
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

ProjectDescription.propTypes = {
  // userId: PropTypes.string.isRequired,
  avatar: PropTypes.string.isRequired,
  ownerName: PropTypes.string.isRequired,
  plan: PropTypes.string.isRequired,
  workName: PropTypes.string.isRequired,
  company: PropTypes.object,
  rating: PropTypes.number,
  program: PropTypes.number,
  renderer: PropTypes.number,
};

export default ProjectDescription;
